export default {
  MuiPopover: {
    styleOverrides: {
      paper: {
        borderRadius: '2px',
        backgroundColor: '#FFFFFF'
      }
    }
  }
};
